import { vesselCardStyles } from "../constants/vessel-card-styles.constants";
import { ChatBubbleLeftRightIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

interface VesselCardCommentsPanelProps {
  comments: string[];
  onAddComment: () => void;
}

const VesselCardCommentsPanel = ({ comments, onAddComment }: VesselCardCommentsPanelProps) => (
  <section data-test="vessel-card-comments" className={twMerge(vesselCardStyles.surface, "xl:col-span-4")}>
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <ChatBubbleLeftRightIcon className="h-5 w-5 text-green" />
        <h2 className={vesselCardStyles.sectionTitle}>DVP comments</h2>
      </div>
      <button
        type="button"
        data-test="vessel-card-add-comment-button"
        onClick={onAddComment}
        className={vesselCardStyles.primaryButton}
      >
        Add comment
      </button>
    </div>
    {comments.length ? (
      <ul className="space-y-2 text-sm leading-6">
        {comments.map((comment, index) => (
          <li
            key={`${comment}-${index}`}
            data-test={`vessel-card-comment-${index}`}
            className="rounded-lg border border-gray-100 bg-gray-50 px-4 py-3 dark:border-gray-700 dark:bg-gray-900/50"
          >
            {comment}
          </li>
        ))}
      </ul>
    ) : (
      <div className="flex min-h-28 items-center justify-center rounded-lg border border-dashed border-gray-300 px-4 text-sm text-gray-500 dark:border-gray-600 dark:text-gray-400">
        <PencilSquareIcon className="mr-2 h-5 w-5" />
        No comments added yet
      </div>
    )}
  </section>
);

export default VesselCardCommentsPanel;
